import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import FmFileEditDto from 'app/admin/fileManager/dto/FmFileEditDto';
import FileResultDto from 'modules/base/dto/file/FileResultDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class FmFileEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'fmFileEditControl';
	}

	/**
	 * @return {Promise<FmFileEditDto>>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new FmFileEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<FmFileEditDto>>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new FmFileEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {FmFileEditDto} dto
	 * @return {Promise<EntityValidationResult>>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {FmFileEditDto} dto
	 * @return {Promise<EntityValidationResult>>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} key
	 * @return {Promise<FileResultDto>}
	 */
	getInfo(key) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getInfo`, {
					key
				})
				.then(response => resolve(new FileResultDto().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new FmFileEditService();
